import {
  BURNABLE_REWARD_TYPES,
  CampaignAccessReward,
  CampaignAccessRewardData,
  PromocodeReward,
  RewardAttributes,
  RewardI18nAttributes,
} from './rewards.types';
import { ProgramAttributes } from '../gamification-api-client';
import { uuid } from '../utils';

/**
 * Determines if a reward is sold out.
 * @param reward
 */
export function isSoldOut(reward: RewardAttributes): boolean {
  switch (reward.type) {
    case 'CAMPAIGN_ACCESS':
      return (
        !reward.data?.accessData?.nbParticipations ||
        (reward.promocodeStats?.wonCodes || 0) >= reward.data?.accessData.nbParticipations
      );
    case 'PROMOCODE':
      return (
        !reward.promocodeStats?.totalCodes ||
        reward.promocodeStats.wonCodes >= reward.promocodeStats.totalCodes
      );
    case 'CAMPAIGN_CODE':
      return false;
    default:
      return true;
  }
}

export function isBurnableReward(
  reward: RewardAttributes,
): reward is CampaignAccessReward | PromocodeReward {
  return BURNABLE_REWARD_TYPES.includes(reward.type);
}

export function createReward(
  accountId: string,
  program: ProgramAttributes,
  i18nAttributes?: RewardI18nAttributes,
  data?: CampaignAccessRewardData,
): Partial<RewardAttributes> {
  return {
    id: uuid(),
    accountId,
    programId: program.id,
    i18nAttributes:
      i18nAttributes ||
      program.languages.reduce(
        (langs, current) => ({
          ...langs,
          [current]: {
            name: '',
            description: '',
            icon: '',
          },
        }),
        {},
      ),
    data,
  };
}
